import { useState, useEffect } from 'react';
import { urlWhatsapp } from '../content';

export default function WhatsAppButton() {
  const [visible, setVisible] = useState(false);
  const href = urlWhatsapp('administrativo');

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 1500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`whatsapp-fab ${visible ? 'whatsapp-fab--visible' : ''}`}
      aria-label="Falar pelo WhatsApp"
    >
      {/* Anel de pulso */}
      <span className="whatsapp-fab__pulse" />

      {/* Ícone SVG do WhatsApp */}
      <svg viewBox="0 0 24 24" fill="currentColor" width="28" height="28">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
      </svg>

      {/* Tooltip */}
      <span className="whatsapp-fab__tooltip">Fale conosco</span>

      <style>{`
        .whatsapp-fab {
          position: fixed;
          bottom: 32px;
          right: 32px;
          z-index: 999;
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background: #25D366;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 8px 28px rgba(37,211,102,.45);
          text-decoration: none;
          opacity: 0;
          transform: scale(0.6) translateY(20px);
          transition: opacity .4s ease, transform .4s cubic-bezier(.2,.8,.2,1), box-shadow .3s;
        }
        .whatsapp-fab--visible {
          opacity: 1;
          transform: scale(1) translateY(0);
        }
        .whatsapp-fab:hover {
          background: #1ebe5d;
          box-shadow: 0 12px 36px rgba(37,211,102,.6);
          transform: scale(1.1) translateY(-3px);
          color: #fff;
        }
        .whatsapp-fab__pulse {
          position: absolute;
          inset: 0;
          border-radius: 50%;
          background: #25D366;
          animation: waPulse 2.5s ease-out infinite;
          z-index: -1;
        }
        .whatsapp-fab__tooltip {
          position: absolute;
          right: calc(100% + 14px);
          top: 50%;
          transform: translateY(-50%);
          background: #0C1A2E;
          color: #fff;
          font-family: 'Outfit', sans-serif;
          font-size: 13px;
          font-weight: 500;
          white-space: nowrap;
          padding: 8px 14px;
          border-radius: 8px;
          pointer-events: none;
          opacity: 0;
          transition: opacity .2s, transform .2s;
          transform: translateY(-50%) translateX(6px);
        }
        .whatsapp-fab__tooltip::after {
          content: '';
          position: absolute;
          left: 100%;
          top: 50%;
          transform: translateY(-50%);
          border: 6px solid transparent;
          border-left-color: #0C1A2E;
        }
        .whatsapp-fab:hover .whatsapp-fab__tooltip {
          opacity: 1;
          transform: translateY(-50%) translateX(0);
        }
        @keyframes waPulse {
          0%   { transform: scale(1);   opacity: .6; }
          70%  { transform: scale(1.55); opacity: 0; }
          100% { transform: scale(1.55); opacity: 0; }
        }
        @media (max-width: 600px) {
          .whatsapp-fab { bottom: 20px; right: 20px; width: 54px; height: 54px; }
          .whatsapp-fab__tooltip { display: none; }
        }
      `}</style>
    </a>
  );
}